import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import groupProgress from 'src/examples/Progress/group';
import variantsProgress from 'src/examples/Progress/variants';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  groupProgress,
  variantsProgress,
  React
};